// React Imports
import { createStore, applyMiddleware, compose } from "redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore, persistReducer } from "redux-persist";
import { BrowserRouter as Router } from "react-router-dom";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
import React from "react";

import { ThemeProvider } from "@mui/material";

// Local Imports
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./hooks/useAuth";
import rootReducer from "./redux/rootReducer";
import rootSaga from "./redux/rootSaga";
import theme from "./theme";
import "./index.css";

import LoginContainer from "./components/LoginContainer/LoginContainer";
import LoadingData from "./components/LoadingData/LoadingData";
import App from "./App";

const composeEnhancers =
    typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose,
  sagaMiddleware = createSagaMiddleware(),
  persistConfig = {
    key: "aoedeRoot",
    storage,
  },
  persistedReducer = persistReducer(persistConfig, rootReducer),
  store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware))
  ),
  persist = persistStore(store);

sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate
      loading={
        <LoginContainer>
          <LoadingData />
        </LoginContainer>
      }
      persistor={persist}
    >
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <Router>
            <App data-testid="app-test-id" />
          </Router>
        </ThemeProvider>
      </AuthProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
